/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Max_Lines_HelpInputs */

const en_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines per subtitle (1-4)`)
};

const fr_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes par sous-titre (1-4)`)
};

const de_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilen pro Untertitel (1-4)`)
};

const it_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righe per sottotitolo (1-4)`)
};

const ru_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество строк в субтитрах (1-4)`)
};

const es_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Líneas por subtítulo (1-4)`)
};

const zh_cn2_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每条字幕的行数（1-4行）`)
};

const ja_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕の行数（1～4）`)
};

const hi_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक में पंक्तियों की संख्या (1-4)`)
};

const pt_pt2_audio_description_export_subtitle_max_lines_help = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas por legenda (1-4)`)
};

/**
* | output |
* | --- |
* | "Lines per subtitle (1-4)" |
*
* @param {Audio_Description_Export_Subtitle_Max_Lines_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_max_lines_help = /** @type {((inputs?: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Max_Lines_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_subtitle_max_lines_help(inputs)
	if (locale === "de") return de_audio_description_export_subtitle_max_lines_help(inputs)
	if (locale === "it") return it_audio_description_export_subtitle_max_lines_help(inputs)
	if (locale === "ru") return ru_audio_description_export_subtitle_max_lines_help(inputs)
	if (locale === "es") return es_audio_description_export_subtitle_max_lines_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_subtitle_max_lines_help(inputs)
	if (locale === "ja") return ja_audio_description_export_subtitle_max_lines_help(inputs)
	if (locale === "hi") return hi_audio_description_export_subtitle_max_lines_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_subtitle_max_lines_help(inputs)
	return en_audio_description_export_subtitle_max_lines_help(inputs)
});